<template>
    <div>
        <pagamentos
            :pagamentos="pagamentosFiltrados"
            v-show="mostrarPagamentos"
            @atualizar-listagem="obterPagamentos()"
        >
            <template slot="controles">
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Situacao</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="situacoesPagamentosSelect"
                                v-model="situacaoPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusPagamentosSelect"
                                v-model="statusPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('APPSE-UABS-PAG-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharPagamento(data.pagamentoId)"
                    ></i>
                </span>
            </template>
        </pagamentos>
        <router-view></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamentos from '@/app/appsebrae/consultorias/componentes/pagamentos/Pagamentos'
import StatusPorSituacao from './StatusPorSituacao'

export default {
    data() {
        return {
            pagamentos: [],
            pagamentosFiltradosSituacao: [],
            pagamentosFiltrados: [],
            statusPagamentos: -1,
            statusPagamentosSelectBase: [
                { text: 'TODOS', value: -1 },
                { text: 'CRIADO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'EM PROCESSAMENTO PELO SETOR FINANCEIRO', value: 2 },
                { text: 'REPROVADO', value: 3 },
                { text: 'REPROVADO PELO SETOR FINANCEIRO', value: 4 },
                { text: 'CONCLUÍDO', value: 5 }
            ],
            statusPagamentosSelect: [],
            situacaoPagamentos: 2,
            situacoesPagamentosSelect: [
                { text: 'TODOS', value: 0 },
                { text: 'NÃO RECEBIDOS', value: 1 },
                { text: 'EM ANÁLISE', value: 2 },
                { text: 'APROVADOS', value: 3 }
            ],
            dataInicial: null,
            dataFinal: null,
            setInicial: true
        }
    },

    methods: {
        obterPagamentos() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                situacao: this.situacaoPagamentos,
                status: this.statusPagamentos,
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            PagamentosServicos.obterTodos(filtroDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.pagamentos = response.data
                        this.pagamentosFiltrados = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter finalizações',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharPagamento(id) {
            this.$router.push({
                name: `AppSebrae_Consultorias_Uabs_Pagamentos_Detalhar`,
                params: {
                    pagamentoId: id
                }
            })
        },

        processarFiltroStatus(regra) {
            let situacoesPorRegra = StatusPorSituacao.filter(item => {
                return item.regra == regra
            })

            let situacao = situacoesPorRegra[0].situacoes.filter(item => {
                return item.id == this.situacaoPagamentos
            })

            this.statusPagamentosSelect = this.statusPagamentosSelectBase.filter(
                item => {
                    return situacao[0].status.some(p => p == item.value)
                }
            )

            if (
                !this.statusPagamentosSelect.some(
                    p => p.value == this.statusPagamentos
                )
            ) {
                this.statusPagamentos = -1
            } else {
                this.obterPagamentos()
            }
        },

        processarFiltroSituacao() {
            if (this.situacaoPagamentos === 0) {
                this.pagamentosFiltradosSituacao = this.pagamentos.slice()
                this.statusPagamentosSelect = this.statusPagamentosSelectBase.slice()
                this.obterPagamentos()
            } else if (this.$temAcessoView('APPSE-UABS-PAG-02')) {
                this.processarFiltroStatus('APPSE-UABS-PAG-02')
            } else if (this.$temAcessoView('APPSE-UFI-PAG-00')) {
                this.processarFiltroStatus('APPSE-UFI-PAG-00')
            }
        }
    },

    created() {
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
        this.setInicial = false
        this.processarFiltroSituacao()
    },

    computed: {
        mostrarPagamentos() {
            return this.$route.name === 'AppSebrae_Consultorias_Uabs_Pagamentos'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'AppSebrae_Consultorias_Uabs_Pagamentos') {
                if (this.$store.getters.recarregar) {
                    this.obterPagamentos()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        statusPagamentos() {
            this.obterPagamentos()
        },

        situacaoPagamentos() {
            this.processarFiltroSituacao()
        },

        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
            if (!this.setInicial) {
                this.processarFiltroSituacao()
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
            if (!this.setInicial) {
                this.processarFiltroSituacao()
            }
        }
    },

    components: {
        Pagamentos
    }
}
</script>
